module.exports = __webpack_public_path__ + "img/ikcak.ae59c49a.png";